import React from 'react';
import axios from "../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import {CardBody, CardTitle, FormGroup, Input, Label} from "reactstrap";

class PostalCode extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.postalCode,
            name: null,
            lastName: null,
            fullAddress: null,
        };
    }

    componentDidMount() {
        this.do();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            this.setState({id: this.props.postalCode});
        }
    }

    do = () => {
        this.props.showSpinner();
        axios.get('api/CustomerApi/GetInquiryPostalCodeData?postalCode=' + toEnglishNumbers(this.state.id))
            .then((res) => {
                this.props.hideSpinner();
                if (res.data === null) {
                    this.props.showAlert("هیچ اطلاعاتی موجود نیست", "info");
                } else if (res.data.isSuccessful) {
                    this.setState({
                        name: res.data.name,
                        lastName: res.data.lastName,
                        fullAddress: res.data.fullAddress
                    });
                    this.props.showAlert("کد پستی معتبر می‌باشد", "success");
                } else {
                    this.props.showAlert("کد پستی نامشخص", "warning");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    render() {
        return (
            <CardBody>
                <CardTitle>
                    نتیجه استعلام کد پستی
                </CardTitle>

                <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center align-items-center">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد پستی</Label>
                        <Input value={this.state.id} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام</Label>
                        <Input value={this.state.name} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام خانوادگی</Label>
                        <Input value={this.state.lastName} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.fullAddress} readOnly/>
                    </FormGroup>
                </div>
            </CardBody>
        );
    }
}

export default PostalCode;
